<template>
    <label :class="size" class="ui-input ui-input-number">
        <div v-if="label" class="label">
            <span v-html="label"></span>
            <span class="label-required" v-if="required">*</span>
        </div>

        <div class="content">
            <span :class="{ 'disabled': disabled }"
                class="button"
                type="button"
                @click="decrement">
                <i class="fal fa-minus" />
            </span>

            <input v-number
                :data-ui="dataUi"
                :value="counter"
                :disabled="disabled"
                class="input"
                type="tel"
                autocomplete="off"
                ref="field_value"
                @input="update" />

            <span :class="{ 'disabled': disabled }"
                class="button"
                type="button"
                @click="increment">
                <i class="fal fa-plus" />
            </span>
        </div>
    </label>
</template>

<script>
    import { number } from '@/directives'
import { data } from 'vue-popperjs'

    export default {
        directives: {
            number,
        },

        props: {
            /**
             * Defines the displayed monetary value
             */
            value: {
                required: true,
                default: 0
            },

            /**
             * Defines a max value to the input
             */
            maxValue: {
                type: null,
                required: true
            },

            /**
             * Defines a max value to the input
             */
            minValue: {
                type: Number,
                required: false,
                default: 1
            },
            
            /**
             * Use to apply classes
             */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
            
            /**
             * Use to apply description
             */
            label: {
                type: String,
                required: false,
            },

            /**
             * Use to disable input
             */
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * define the input as required in html5 and apply the '*' operator to the label
             */
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            dataUi: {
                type: String,
                required: false,
                default: ''
            },
        },

        data() {
            return {
                min: this.minValue
            }
        },

        computed: {
            max() {
                return ['string', 'number'].includes(typeof this.maxValue)
                    ? parseInt(this.maxValue)
                    : 1000000
            },
            counter: {
                get() {
                    return parseInt(this.value) || this.min
                },
                set(value) {
                    this.$emit('input', parseInt(value))
                },
            }
        },

        mounted() {
            this.setMinMax()
        },

        watch: {
            maxValue: {
                deep: true,
                handler() {
                    this.setMinMax()
                }
            },
            value: {
                deep: true,
                handler() {
                    this.setMinMax()
                }
            }
        },

        methods: {
            /**
             * Verifica se o valor atual é maior do que o máximo, altera o valor para o
             * valor máximo
             */
            setMinMax() {
                if (parseInt(this.value) > this.max) {
                    this.counter = this.max

                } else if (!this.value || parseInt(this.value) < this.min) {
                    this.counter = this.min
                }
            },
            /**
             * Emits an event as soon as any change in any of the inputs occurs
             */
            update(e) {
                /** Check that the entered value is greater than the maximum value */
                if (e.target.value && parseInt(e.target.value) >= this.max) {
                    e.target.value = this.max
                    this.counter = this.max
                } else {
                    this.counter = parseInt(e.target.value) || this.min
                }
            },
            /**
             * Adds one unit to the total value
             */
            increment() {
                if (this.counter >= this.max) return

                this.counter++
                this.$nextTick()
            },

            /**
             * Dimension one unit to the total value
             */
            decrement() {
                if (this.counter <= this.min) return

                this.counter--
                this.$nextTick()
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>